/**
 * Base environment configuration for Agent app.
 * All environment files should spread this object.
 */
export const environmentBase = {
  appName: 'Service',
  appSubtitle: 'Fair queue and classroom support, powered by CrowdCTRL',
  /**
   * Optional public links for the login screen (e.g. prize demos, pilots).
   * Set in environment.ts / prod overrides as needed.
   */
  registerInterestUrl: '',
  contactEmail: '',
  /**
   * reCAPTCHA v3 site key (public). Required with `apiUrl` for inline Register interest / Contact forms.
   * Must match the secret configured as RECAPTCHA_SECRET_KEY on Cloud Functions.
   */
  recaptchaSiteKey: '6Le1dbEsAAAAAFNB3-2_zjP_HhXd18GPt3gZ8eca',
  /**
   * Public Forms app origin for short links and printed ticket `/o/:id` URLs (no trailing slash).
   * Keep in sync with `FORMS_PUBLIC_BASE_URL` on Cloud Functions (`functions/src/config/public_urls.py`)
   * so QR/NFC `shortUrl` from the API matches ticket copy and QR payload.
   */
  formsPublicBaseUrl: 'https://forms.crowdctrl.app',
};
